export var CreditNoteTableTypes;
(function (CreditNoteTableTypes) {
    CreditNoteTableTypes["CREDIT_NOTE"] = "credit_note";
    CreditNoteTableTypes["OVERPAYMENT"] = "overpayment";
    CreditNoteTableTypes["PREPAYMENT"] = "prepayment";
    CreditNoteTableTypes["UNAPPLIED_PAYMENT"] = "unapplied_payment";
})(CreditNoteTableTypes || (CreditNoteTableTypes = {}));
//# sourceMappingURL=creditNote.js.map